.ux-u-silent-auth {
  display: block;

  iframe {
    border: 0 none transparent;
    height: 1px;
    left: -1000px;
    position: absolute;
    top: -1000px;
    width: 1px;
  }
}
